import type { AllRouteEndpoints } from "../routeTypes";

export const patchApiCalculatedFiltersAppGroupIdUnarchiveCacheKeys: AllRouteEndpoints[] = [
  "/api/calculated_filters/:app_group_id",
];
